<div class="page-wrap">
  <section class="glass-panel hero-panel">
    <div>
      <p class="eyebrow">Command Center</p>
      <h1 class="hero-title">Run onboarding, messaging, and coexistence from a single dashboard.</h1>
    </div>
    <div class="hero-aside">
      <p class="subtle-copy">
        Current onboarding status:
        <strong>{{ summary.onboardingStatus }}</strong>
      </p>
      <ion-button routerLink="/app/setup">Complete setup</ion-button>
    </div>
  </section>

  <section class="metric-grid section-block">
    <article class="glass-panel metric-card">
      <p class="eyebrow">Templates</p>
      <h2>{{ summary.activeTemplates }}</h2>
      <p class="subtle-copy">Approved or draft template records available for campaigns.</p>
    </article>
    <article class="glass-panel metric-card">
      <p class="eyebrow">Contacts</p>
      <h2>{{ summary.totalContacts }}</h2>
      <p class="subtle-copy">Audience records synced and ready for bulk delivery.</p>
    </article>
    <article class="glass-panel metric-card">
      <p class="eyebrow">Campaigns</p>
      <h2>{{ summary.campaignsSent }}</h2>
      <p class="subtle-copy">Campaigns created and dispatched through Cloud API.</p>
    </article>
    <article class="glass-panel metric-card">
      <p class="eyebrow">Delivery Rate</p>
      <h2>{{ summary.deliveryRate }}%</h2>
      <p class="subtle-copy">Recent delivery performance from message logs.</p>
    </article>
  </section>

  <section class="card-grid section-block">
    <article class="glass-panel content-card">
      <p class="eyebrow">Coexistence</p>
      <h3 class="section-title">Same number, two modes of work</h3>
      <p class="subtle-copy">
        Manual chats can continue in the WhatsApp Business App while template campaigns are sent via
        API without forcing account deletion.
      </p>
    </article>

    <article class="glass-panel content-card">
      <p class="eyebrow">Launch Checklist</p>
      <ion-list lines="none">
        <ion-item>Register and authenticate user</ion-item>
        <ion-item>Connect Facebook Business Manager</ion-item>
        <ion-item>Verify phone number and create WABA</ion-item>
        <ion-item>Create template and send first campaign</ion-item>
      </ion-list>
    </article>
  </section>

  <section class="glass-panel logs-panel section-block">
    <div class="panel-heading">
      <div>
        <p class="eyebrow">Recent Logs</p>
        <h3 class="section-title">Message activity</h3>
      </div>
    </div>

    <ion-list lines="full">
      <ion-item *ngFor="let log of summary.recentLogs">
        <ion-label>
          <h3>{{ log.campaign_name }} · {{ log.contact_name }}</h3>
          <p>{{ log.template_name }} · {{ log.sent_at | date: 'medium' }}</p>
        </ion-label>
        <ion-badge [color]="log.delivery_status === 'delivered' ? 'success' : 'warning'">
          {{ log.delivery_status }}
        </ion-badge>
      </ion-item>
    </ion-list>
  </section>
</div>
